/*
 * PhoneAuthenticatorCodeSection Messages
 *
 * This contains all the text for the PhoneAuthenticatorCodeSection component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.PhoneAuthenticatorCodeSection";

export default defineMessages(scope, {
  header:
    "A code was sent to your phone. Enter the code below to verify. Carrier messaging charges may apply.",
  enterCode: "Enter Code",
  submitButton: "Verify",
  cancelButton: "Cancel",
  required: "Code is required",
  numbersOnly: "Only Numbers",
  restart: "Didn't get code? Click here",
});
